import React from 'react';

import { GlobalMessages } from '../../types/Messages';
import { LayoutExtension } from '../../types/ResponsiveState';
import { messageHooks } from '../messageHooks/messageHooks';

export const layoutHooks = {
  useDesktop() {
    const layoutExtension = messageHooks.useSubjectState(GlobalMessages.LayoutExtension);

    const isDesktop = React.useMemo(() => {
      return (
        layoutExtension
        && [LayoutExtension.DesktopSmall, LayoutExtension.DesktopLarge].includes(layoutExtension)
      );
    }, [layoutExtension]);

    return { isDesktop: !!isDesktop };
  },

  useDesktopLarge() {
    const layoutExtension = messageHooks.useSubjectState(GlobalMessages.LayoutExtension);

    const isDesktopLarge = React.useMemo(() => {
      return (
        layoutExtension && LayoutExtension.DesktopLarge.includes(layoutExtension)
      );
    }, [layoutExtension]);

    return { isDesktopLarge: !!isDesktopLarge };
  },

  useMobileLayout() {
    const layoutExtension = messageHooks.useSubjectState(GlobalMessages.LayoutExtension);
    const isMobile = React.useMemo(
      () => layoutExtension && layoutExtension === LayoutExtension.Mobile,
      [layoutExtension],
    );
    return !!isMobile;
  },

  useLayout() {
    return messageHooks.useSubjectState(GlobalMessages.Layout);
  },

  useLayoutExtension() {
    return messageHooks.useSubjectState(GlobalMessages.LayoutExtension);
  },
};
